<div class="textarea-wrapper" [class]="size" [class.error]="error" [class.has-leading-icon]="leadingIcon">
    @if (label) {
      <label class="textarea-label">{{ label }}</label>
    }
    
    <div class="textarea-container">
      @if (leadingIcon) {
        <button 
          type="button" 
          class="leading-icon-btn" 
          [disabled]="disabled"
          (click)="onLeadingIconClick()"
        >
          <lucide-icon [name]="leadingIcon" [size]="20"></lucide-icon>
        </button>
      }
      
      <textarea
        #textareaRef
        pTextarea
        [placeholder]="placeholder"
        [value]="value"
        [attr.disabled]="disabled ? true : null"
        [rows]="rows"
        [attr.maxlength]="maxLength"
        class="custom-textarea"
        (input)="onInput($event)"
        (blur)="markAsTouched()"
        (focus)="onFocus()"
      ></textarea>
    </div>

    <div class="textarea-footer">
      @if (helperText && !error) {
        <span class="helper-text">{{ helperText }}</span>
      }
      @if (error && errorMessage) {
        <span class="error-message">{{ errorMessage }}</span>
      }
      @if (maxLength) {
        <span class="char-counter">{{ 'common.charCount' | transloco: { count: (value || '').length, max: maxLength } }}</span>
      }
    </div>
</div>